<template>
    <div class="EquipmentAccount">
        <div class="left">
            <div class="search">
                <el-input placeholder="输入设备名称以搜索" suffix-icon="el-icon-search" v-model="keyword">
                </el-input>
                <div class="all">全部设备
                    <template v-if="homeitem.roleId=='-9999'">
                        <span class="edit" @click="editmodeFun" v-if="!editmode">编辑模式</span><span class="edit red" v-else
                        @click="exitFun">退出编辑</span>
                    </template>
                </div>
            </div>
            <div class="mytree" :class="{ editmode: editmode }">
                <el-tree ref="tree" :data="list" default-expand-all :props="defaultProps" @node-click="handleNodeClick" 
                    :filter-node-method="filterNode">
                    <div class="custom-tree-node" slot-scope="{ node, data }"
                        :class="{ 'checked': (data.deviceId === currentLoop.deviceId) && currentLoop.deviceId, 'row-center': !data.add, 'isadd': data.add }" >
                        <span class="name" :title="data.deviceName" v-if="!data.edit" :id="data.deviceId">{{ data.deviceName }}<i
                                v-if="data.count">({{ data.count }} 台)</i></span>
                        <span v-else><el-input v-model="data.deviceName" placeholder="请输入内容"
                                style="width:138px;"></el-input></span>
                        <span class="add" v-if="data.add === true && editmode" @click.stop="() => append(data,node)"><i
                                class="el-icon-circle-plus-outline"></i>添加设备</span>
                        <span class="handle" v-if="data.edit != undefined && editmode">
                            <!-- <img src="@/assets/img/edit.png" alt="" style="width:16px" title="编辑" v-if="!data.edit"
                                @click.stop="editFun(data)">
                            <img src="@/assets/img/save.png" alt="" ref="save" style="width:16px" title="保存" v-else
                                @click.stop="saveGroup(data, node)"> -->
                            <i class="el-icon-circle-close" style="color:#0D94FF;font-size:18px" title="取消"
                                @click.stop="cancelFun(node, data)" v-if="data.edit"></i>
                            <i class="el-icon-delete" style="color:#FD4238;font-size:18px" title="删除"
                                @click.stop="deleteFun(data)" v-else></i>
                        </span>
                    </div>
                </el-tree>
            </div>
        </div>
        <div class="right">
            <Detail :currentLoop="currentLoop" :editmode="editmode" @updateDevice="updateDevice" :isupadte="isupadte" @getisupadte="getisupadte"></Detail>
        </div>
    </div>
</template>

<script>
import { deviceAll, deviceAccount, DeviceUpdate, DeviceAdd, DeviceDelete } from "../../api/power";
import { loadBMap } from '@/util/map'
import Detail from './detail'
export default {
    data() {
        return {
            editmode: false,
            defaultProps: {
                children: 'listData',
                label: 'deviceName'
            },
            list: [],
            keyword: "",
            imglist: [
                require("../../assets/img/gf1.png"),
                require("../../assets/img/pd1.png"),
                require("../../assets/img/wg1.png")
            ],
            currentLoop: {},
            id: 0,
            isupadte:false
        };
    },
    components: {
        Detail
    },
    computed: {
        homeitem(){
            return this.$store.state.homeitem.user
        },
        projectInfo() {
            return this.$store.state.project.projectInfo
        },
        EnterpriseInfo() {
            return this.$store.state.project.EnterpriseInfo
        },
        result() {
            let onRecursionData = (arr, val) => {
                let newarr = []
                arr.forEach(item => {
                    if (item.children && item.children.length) {
                        let children = onRecursionData(item.children, val)
                        let obj = {
                            ...item,
                            children
                        }
                        if (children && children.length) {
                            newarr.push(obj)
                        }
                    } else {
                        if (item.label.includes(val)) {
                            newarr.push(item)
                        }
                    }
                })
                return newarr
            }
            let result = onRecursionData(this.list, this.keyword)
            // console.log(result,"result",this.list)
            return result
        }
    },
    watch: {
        list(n, o) {

        },
        keyword(val) {
            this.$refs.tree.filter(val);
        },
        currentLoop(n, o) {
            
        },
        editmode(n){
            this.getDeviceAll()
        }
    },
    mounted() {
        this.getDeviceAll()
    },
    methods: {
        cancelFun(node, data){
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            // const index = children.listData.findIndex(d => d.id === data.id);
            children.listData.splice(0, 1);
            this.currentLoop = children.listData[0]
        },
        getisupadte(){
            this.isupadte = false
        },
        updateDevice(data) {
            this.getDeviceAll(data)
        },
        append(data,node) {
            // this.isEdit(this.list)

            const newChild = { deviceId: 0, id:this.id++, deviceName: '未命名设备' + this.id, edit: true, listData: [], isadd: true,lookupId:data.lookupId,deviceName2:data.deviceName };
            if (!data.listData) {
                this.$set(data, 'listData', []);
            }
            let self = this
            setTimeout(function(){
                data.listData.unshift(newChild);
                self.currentLoop = newChild
            },100)
            // this.currentLoop = newChild
        },
        //退出编辑
        exitFun() {
            this.editmode = false
            this.expandedData(this.list)
        },
        editmodeFun() {
            this.editmode = true
        },
        async saveGroup(data, node) {
            if (data.isadd) {  //新增
                let obj = {
                    deviceName: data.deviceName,
                    lookupId: node.parent.data.lookupId,
                    projectId: this.$store.getters.projectId
                }
                let result = await DeviceAdd(obj);
                if (result.data.status) {
                    data.edit = false
                    this.$message.success('新增成功！');
                    this.getDeviceAll(result.data.data.result)
                }else{
                    this.$message.error(result.data.errMsg);
                }
            } else {
                let obj = {
                    deviceName: data.deviceName,
                    deviceId: data.deviceId
                }
                let result = await DeviceUpdate(obj);
                if (result.data.status) {
                    data.edit = false
                    // this.$message.success('修改成功！');
                }else{
                    this.$message.error(result.data.errMsg);
                }
            }
        },
        editFun(data) {
            this.expandedData(this.list)
            data.edit = !data.edit
            // this.isEdit(this.list)
        },
        
        expandedData(list,data) {
            list.forEach((item,index)=>{
                item.edit = false
                if(item.listData&&item.listData.length>0){
                    this.expandedData(item.listData)
                }
            })
        },
        isEdit(list) {  //实时保存
            let self = this
            list.forEach((item,index)=>{
                if(item.edit){
                    if(item.loopId==undefined||(item.loopId!=this.currentLoop.loopId)){
                        this.isupadte = true
                    }
                    // this.$refs.save.dispatchEvent(new MouseEvent('click'));
                    // setTimeout(function(){
                    //     self.currentLoop = item
                    // },100)
                }
                if(item.listData&&item.listData.length>0){
                    this.isEdit(item.listData)
                }
            })
        },
        deleteFun(data) {
            this.$confirm(data.deviceName + "设备", '您要删除的是？', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: '',
                customClass: "message_box"
            }).then(async () => {
                let obj = {
                    deviceId: data.deviceId
                }
                let result = await DeviceDelete(obj);
                if (result.data.status) {
                    this.$message.success('删除成功！');
                    this.getDeviceAll()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });
            });
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.deviceName.indexOf(value) !== -1;
        },

        handleNodeClick(data,node) {
            data.lookupId = node.parent.data.lookupId
            this.currentLoop = data;
        },
        currDevice(list){
            list.forEach((item,index)=>{
                // if(item.listData&&item.listData.length>0){
                //     this.currentLoop = item.listData[0]
                //     return
                // }else{
                //     this.currDevice(item.listData);
                // }
                let data = item.listData[0].listData[0]
                if(data){
                    this.currentLoop = data
                    return
                }else{
                    this.currDevice(item.listData);
                }
            })
        },
        rebuildData(list,parent) {  //递归
            list.forEach((item,index)=>{
                if(item.name){
                    item.deviceName = item.name;
                    item.deviceId = Math.random()
                    item.currId = 0
                    if(item.listData&&item.listData.length>0){
                        this.rebuildData(item.listData,item);
                    }
                }else{
                    item.edit = false
                    item.lookupId = parent.lookupId
                }
                if(item.currId==0&&item.name!="高压"&&item.name!="低压"){
                    item.add = true
                }
            })
        },
        async getDeviceAll(curr) {
            let result = await deviceAccount();
            let data = result.data.data;

            this.rebuildData(data);
            // console.log(data,"data")
            if(!this.editmode){
                let num = 0
                data = data.filter(item=>{
                    if(item.count==0){
                        num++
                    }
                    if(item.listData){
                        item.listData = item.listData.filter((elm,index)=>{
                            if(elm.count!=0){
                                return elm
                            }
                        })
                    }
                    if(item.count>0){
                        return item
                    }
                })

                if(num==data.length){
                    this.list = []
                }else{
                    this.list = data
                }

            }else{
                this.list = data
            }

            if(curr){
                this.currentLoop = curr
                setTimeout(() => {
                    const node = document.getElementById(curr.deviceId)
                    if (node) {
                        node.scrollIntoView({ block: 'center' })
                    }
                }, 100)
            }else{
                // this.currDevice(this.list)
                // return
                if (this.list[0].listData.length > 0) {
                    if(this.list[0].listData[0].listData.length>0){
                        this.currentLoop = this.list[0].listData[0].listData[0]
                    }else{
                        this.currentLoop = {}
                    }
                } else {
                    this.currentLoop = this.list[1].listData[0].listData[0]
                }
            }
        },
    }
};
</script>

<style scoped lang="less">
/deep/ .mytree {
    height: calc(100% - 10vh);
    // padding: 10px;
    padding-right: 20rem;
    overflow-y: auto;


    .handle {
        img {
            margin-right: 5rem;
        }
    }

    .el-input__inner {
        height: 32px !important;
    }

    .el-tree {
        color: #333333;
    }

    .el-tree>.el-tree-node:after {
        border-top: none;
    }

    .el-tree-node {
        position: relative;

        //  padding-left: 12px;
        .el-tree-node__children {
            .el-tree-node__children {
                border: 0;
            }

            .el-tree-node__content {
                background: none;
                margin-bottom: 0px;
            }
        }
    }

    //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
    .el-tree-node__expand-icon.is-leaf {
        display: none;
    }

    .el-tree-node__children {
        padding-left: 18px;
        border: 1px solid #F2F2F2;
        border-radius: 0px 0px 4px 4px;
    }

    .el-tree-node :last-child:before {
        height: 38px;
    }

    .el-tree>.el-tree-node:before {
        border-left: none;
    }

    .el-tree>.el-tree-node:after {
        border-top: none;
    }

    .el-tree-node:before {
        content: '';
        left: 0px;
        position: absolute;
        right: auto;
        border-width: 1px;
    }

    .el-tree-node:after {
        content: '';
        left: 0px;
        position: absolute;
        right: auto;
        border-width: 1px;
        border-top: 1px dashed #E5E5E5;
        height: 20px;
        top: 14px;
        width: 11px;
    }

    .el-tree-node:before {
        border-left: 1px dashed #E5E5E5;
        bottom: 0px;
        height: 100%;
        top: -26px;
        width: 1px;
    }

    .el-tree .el-tree-node__expand-icon.expanded {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    .el-tree .el-icon-caret-right:before {
        content: "+";
        border: 1px solid #666;
        border-radius: 2px;
        height: 14px;
        width: 14px;
        line-height: 14px;
        font-size: 16px;
        color: #666;
        text-align: center;
        position: absolute;
        left: -20px;
        top: -8px;
    }

    .el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
        content: "-";
        font-size: 18px;
        color: #666;
        line-height: 12px;
        position: absolute;
        left: -20px;
        top: -8px;
    }

    .el-tree-node .el-tree-node__children .el-tree-node__children .el-tree-node__children {

        // padding-left: 18px !important;
        .el-tree-node__content {
            // padding-left: 0 !important;
        }
    }

    .el-tree-node__content {
        height: 32px;
        padding-left: 30px !important;
        background: #F2F2F2;
        border-radius: 4px;
        margin-bottom: 10px;
    }

    .el-tree-node__content>.el-tree-node__expand-icon {
        padding: 0;
    }

    .is-leaf+.custom-tree-node {
        font-weight: 400;
    }

    .custom-tree-node {
        width: 100%;
        font-size: 14px;
        justify-content: space-between;
        padding-right: 10px;
        font-weight: 600;

        .name {
            display: inline-block;
            width: 79%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            vertical-align: middle;
        }

        .add {
            font-weight: 500;
            display: none;
            position: absolute;
            top: 32px;

            i {
                color: #269A99;
                font-size: 18px;
                vertical-align: middle;
            }
        }

        label {
            font-weight: bold;
        }
    }

    .el-tree-node.is-expanded {
        .add {
            display: block !important;
        }
    }

    .checked {
        color: #0D94FF;
    }
}

/deep/.editmode {

    .el-tree-node {
        position: relative;

        //  padding-left: 12px;
        .el-tree-node__children {
            .el-tree-node__children {
                border: 0;
                margin-top: 20px;

                .el-tree-node__children {
                    margin-top: 0;
                }
            }

            .el-tree-node__content {
                background: none;
                margin-bottom: 0px;
            }
        }
    }
}

.EquipmentAccount {
    background: #ffffff;
    height: 100%;
    width: 100%;
    display: flex;
    padding: 24rem;

    .left {
        .w(285);
        height: 100%;
        border-right: 1px solid rgba(51, 51, 51, 0.15);

        // padding-right: 24rem;
        .all {
            font-size: 14px;
            line-height: 50px;

            .edit {
                float: right;
                width: 89px;
                height: 29px;
                line-height: 29px;
                text-align: center;
                background: #FFFFFF;
                border: 1px solid #E5E5E5;
                border-radius: 14px;
                color: #0D94FF;
                display: inline-block;
                margin-top: 10px;
                cursor: pointer;
            }

            .red {
                color: #FD4238;
            }
        }
    }

    .search {
        padding-right: 24rem;
    }

    .right {
        flex: 1;
        padding-left: 24rem;
    }
}</style>